
import React from 'react';
import { useParams } from 'umi';
import { useCreation } from 'ahooks';
import { Row, Col } from 'tea-component';
import '@/pages/intelligence/assets/scss/TopCharts/Companies/GamesDetails/subsidiaryCompanies.scss';
import ScInfoCard, { Iprops } from "@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/SubsidiaryCompanies/ScInfoCard";
import { useSubsidiaryCompanies } from './hooks';
import Loading from '@/pages/intelligence/components/Loading';

const SubsidiaryCompanies = () => {
  const { id } = useParams() as any;

  const { data, loading, } = useSubsidiaryCompanies(useCreation(() => ({ "company_id": id }), [id,]))
  if (loading) {
    return <Loading marginTop={300} />;
  }
  return <div className='dbi-subsidiarycompanies'>
    <Row className='dbi-subsidiarycompanies-cont'>
      {data?.map((task: Iprops) => <Col span={8} key={task.company_id}>
        <ScInfoCard {...task} />
      </Col>
      )}
    </Row>
  </div>;
};

export default SubsidiaryCompanies;
